import { Injectable, OnInit, Injector } from "@angular/core";
import { AppComponentBase } from "@shared/common/app-component-base";

export interface IEventWorkSelected {
    id: number;
    name: string;
    userId: number;
    eventWorkId: number;
}

@Injectable()
export class EventWorkHelperService extends AppComponentBase {

    userLogged = this.appSession.user;

    constructor(
        injector: Injector
    ) {
        super(injector);
        this.checkEventWork();
    }

    checkEventWork(): void {

        let eventWork: IEventWorkSelected = this.loadEventWorkSelected();

        if (!this.userLogged || !eventWork || eventWork.userId != this.userLogged.id) {
            localStorage.removeItem('eventWork');
        }        
    }

    loadEventWorkSelected(): IEventWorkSelected {
        return JSON.parse(localStorage.getItem('eventWork'));
    }

    save(eventWork: IEventWorkSelected): void {        
        localStorage.setItem('eventWork', JSON.stringify(eventWork));
    }
}



// WEBPACK FOOTER //
// ./src/app/scientific-work/event-work-header/event-work-helper-service.ts